import { useEffect, useState } from "react";
import "./VisitorCounter.css"

const VisitorCounter = () => {
  const [count, setCount] = useState(129847);

  useEffect(() => {
    // Retrieve count from local storage or set it to 0
    let visitCount = localStorage.getItem("visitCount");
    
    if (!visitCount) {
      visitCount = 129847;
    } else {
      visitCount = parseInt(visitCount) + 1;
    }

    localStorage.setItem("visitCount", visitCount);
    setCount(visitCount);
  }, []);

  return (
    <div className="visitor-counter">
      <p>Visitor Count: <strong>{count}</strong></p>
    </div>
  );
};

export default VisitorCounter;
